import {
  FETCH_CRYPTO_SERVICES_LIST,
  FETCH_CRYPTO_SERVICES_LIST_ERROR,
  CLEAR_FETCH_CRYPTO_SERVICES_LIST,
  FETCH_CRYPTO_LINKS_LIST,
  FETCH_CRYPTO_LINKS_LIST_ERROR,
  CLEAR_FETCH_CRYPTO_LINKS_LIST,
  APPLY_CRYPTO_LINK_DRAG,
  APPLY_CRYPTO_LINK_DRAG_ERROR,
  CLEAR_CRYPTO_LINK_DRAG,
  CREATE_CRYPTO_LINK_SUCCESS,
  CREATE_CRYPTO_LINK_ERROR,
  CLEAR_CREATE_CRYPTO_LINK,
  PATCH_CRYPTO_LINK_SUCCESS,
  PATCH_CRYPTO_LINK_ERROR,
  CLEAR_PATCH_CRYPTO_LINK,
  DELETE_CRYPTO_LINK_SUCCESS,
  DELETE_CRYPTO_LINK_ERROR,
  CLEAR_DELETE_CRYPTO_LINK,
} from 'redux/crypto-links/types';

const initialState = {
  cryptoServicesList: null,
  cryptoServicesListError: null,
  cryptoLinksList: null,
  cryptoLinksListError: null,
  cryptoLinkDrugSuccess: null,
  cryptoLinkDrugError: null,
  createCryptoLinkSuccess: null,
  createCryptoLinkError: null,
  patchCryptoLinkSuccess: null,
  patchCryptoLinkError: null,
  deleteCryptoLinkSuccess: null,
  deleteCryptoLinkError: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CRYPTO_SERVICES_LIST:
      return {
        ...state,
        cryptoServicesList: action.payload.data,
        cryptoServicesListError: null,
      };
    case FETCH_CRYPTO_SERVICES_LIST_ERROR:
      return {
        ...state,
        cryptoServicesList: null,
        cryptoServicesListError: action.payload.data,
      };
    case CLEAR_FETCH_CRYPTO_SERVICES_LIST:
      return {
        ...state,
        cryptoServicesList: null,
        cryptoServicesListError: null,
      };
    case FETCH_CRYPTO_LINKS_LIST:
      return {
        ...state,
        cryptoLinksList: action.payload.data,
        cryptoLinksListError: null,
      };
    case FETCH_CRYPTO_LINKS_LIST_ERROR:
      return {
        ...state,
        cryptoLinksList: null,
        cryptoLinksListError: action.payload.data,
      };
    case CLEAR_FETCH_CRYPTO_LINKS_LIST:
      return {
        ...state,
        cryptoLinksList: null,
        cryptoLinksListError: null,
      };
    case APPLY_CRYPTO_LINK_DRAG:
      return {
        ...state,
        cryptoLinkDrugSuccess: action.payload.data,
        cryptoLinkDrugError: null,
      };
    case APPLY_CRYPTO_LINK_DRAG_ERROR:
      return {
        ...state,
        cryptoLinkDrugSuccess: null,
        cryptoLinkDrugError: action.payload.data,
      };
    case CLEAR_CRYPTO_LINK_DRAG:
      return {
        ...state,
        cryptoLinkDrugSuccess: null,
        cryptoLinkDrugError: null,
      };
    case CREATE_CRYPTO_LINK_SUCCESS:
      return {
        ...state,
        createCryptoLinkSuccess: action.payload.data,
        createCryptoLinkError: null,
      };
    case CREATE_CRYPTO_LINK_ERROR:
      return {
        ...state,
        createCryptoLinkSuccess: null,
        createCryptoLinkError: action.payload.data,
      };
    case CLEAR_CREATE_CRYPTO_LINK:
      return {
        ...state,
        createCryptoLinkSuccess: null,
        createCryptoLinkError: null,
      };
    case PATCH_CRYPTO_LINK_SUCCESS:
      return {
        ...state,
        patchCryptoLinkSuccess: action.payload.data,
        patchCryptoLinkError: null,
      };
    case PATCH_CRYPTO_LINK_ERROR:
      return {
        ...state,
        patchCryptoLinkSuccess: null,
        patchCryptoLinkError: action.payload.data,
      };
    case CLEAR_PATCH_CRYPTO_LINK:
      return {
        ...state,
        patchCryptoLinkSuccess: null,
        patchCryptoLinkError: null,
      };
    case DELETE_CRYPTO_LINK_SUCCESS:
      return {
        ...state,
        deleteCryptoLinkSuccess: action.payload.data,
        deleteCryptoLinkError: null,
      };
    case DELETE_CRYPTO_LINK_ERROR:
      return {
        ...state,
        deleteCryptoLinkSuccess: null,
        deleteCryptoLinkError: action.payload.data,
      };
    case CLEAR_DELETE_CRYPTO_LINK:
      return {
        ...state,
        deleteCryptoLinkSuccess: null,
        deleteCryptoLinkError: null,
      };
    default:
      return state;
  }
};
